// All carriers supported
// Names are the same used in backend-quotes config file
export enum Carrier {
  Allstate = 'allstate',
  Alpha = 'alpha',
  Aviva = 'aviva',
  AvivaElite = 'avivaElite',
  AvivaTraders = 'avivaTraders',
  Bcaa = 'bcaa',
  Belair = 'belair',
  Beneva = 'beneva',
  Caa = 'caa',
  Chieftain = 'chieftain',
  Chubb = 'chubb',
  Coachman = 'coachman',
  Cooperators = 'cooperators',
  Cumis = 'cumis',
  Desjardins = 'desjardins',
  Dumfries = 'dumfries',
  Echelon = 'echelon',
  Economical = 'economical',
  Facility = 'facility',
  Federation = 'federation',
  GoreMutual = 'goreMutual',
  Guarantee = 'guarantee',
  Ia = 'ia',
  Intact = 'intact',
  Intergroupe = 'intergroupe',
  Jevco = 'jevco',
  LaCapitale = 'laCapitale',
  LaPersonnelle = 'laPersonnelle',
  Ledor = 'ledor',
  Lloyds = 'lloyds',
  Missiquoi = 'missiquoi',
  NationalBankIns = 'nationalBankIns',
  Northbridge = 'northbridge',
  Optium = 'optium',
  Other = 'other',
  Pafco = 'pafco',
  PeelMutual = 'peelMutual',
  Pembridge = 'pembridge',
  Perth = 'perth',
  Portage = 'portage',
  Promutuel = 'promutuel',
  Rbc = 'rbc',
  Rsa = 'rsa',
  Sonnet = 'sonnet',
  SquareOne = 'squareOne',
  Ssq = 'ssq',
  StateFarm = 'stateFarm',
  Td = 'td',
  Travelers = 'travelers',
  Unica = 'unica',
  Unique = 'unique',
  Wawanesa = 'wawanesa',
  Western = 'western',
}
